import { getPriceView } from '../../../shared/utils/stringUtils';

export const getPriceOrDash = (value: number | string | undefined | null): string => {
  return value ? getPriceView(value) : '—';
};
